import { useLoader } from '@react-three/fiber';
import type { FC } from 'react';
import { useMemo } from 'react';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';

import { useCardGeometriesStore } from '../../CardGeometriesStore';

type Props = {
  uniqueKey: string;
};

export const HeroMaskGeometry: FC<Props> = ({ uniqueKey }) => {
  const { getAsset } = useCardGeometriesStore();

  const { uri } = useMemo(() => getAsset(uniqueKey) ?? {}, [uniqueKey]);

  const data = useLoader(SVGLoader, uri ?? ''); // TODO this should be moved to CardGeometriesStore and called only once after mask SVG load
  const [shape] = useMemo(() => data.paths[0]?.toShapes(true) ?? [], [data]); // SVG must be just a single path

  return <shapeBufferGeometry attach='geometry' args={[shape]} />;
};
